export function getStartDateForTimeframe(timeframe) {
  const now = new Date();

  switch (timeframe) {
    case "30d":
      return new Date(now.setDate(now.getDate() - 30));
    case "3m":
      return new Date(now.setMonth(now.getMonth() - 3));
    case "6m":
      return new Date(now.setMonth(now.getMonth() - 6));
    case "ytd":
      return new Date(new Date().getFullYear(), 0, 1);
    case "all":
    default:
      return null;
  }
}

// Prefer activity_date/date → fallbackKey (usually uploaded_at or chart_date)
export function getBestItemDate(item, fallbackKey = "uploaded_at") {
  const candidate = item?.activity_date || item?.date || item?.[fallbackKey] || null;
  if (!candidate) return null;

  const d = new Date(candidate);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function filterByTimeframe(items, timeframe, dateKey = "uploaded_at") {
  const startDate = getStartDateForTimeframe(timeframe);
  if (!startDate) return items;

  return (items || []).filter((item) => {
    const itemDate = getBestItemDate(item, dateKey);
    if (!itemDate) return false;
    return itemDate >= startDate;
  });
}
